import { Box, Typography } from "@material-ui/core"
import styled, { useTheme } from "styled-components"

import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';


const StyledReportHeding = styled(Typography)`
    && {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        text-align: left;
        color: ${({ theme }) => theme.colors.accent1};
        margin-bottom: 20px;
    }
`


const StyledReportSubheading = styled(Typography)`
    && {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.accent1};
        text-align: left;
        margin-bottom: 17px;   
    }
`


const StyledReportReasonText = styled(FormControlLabel)`
    && {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.accent1};
    }
`


const StyledRadioButton = styled(Radio) <{ reason: string, label: string }>`
    && {
        color: ${({ theme, reason, label }) => reason === label ? theme.colors.primary : theme.colors.accent1};
    }
`


interface ReportComponentProps {
    setReason?: Function
    reason?: string
    type: string
    setReasonDescription?: Function
}


export const ReportComponent = ({ setReason, reason, type, setReasonDescription }: ReportComponentProps) => {
    const theme = useTheme()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReason((event.target as HTMLInputElement).value);
        setReasonDescription((event.target as HTMLInputElement).value);
    };


    return (
      <Box>
        <StyledReportHeding>Why are you reporting this Content?</StyledReportHeding>

        <Box>
          <StyledReportSubheading>Report Category</StyledReportSubheading>
          <Box display="flex" flexDirection="column" alignItems="flex-start" marginBottom="19px">
            <FormControl component="fieldset">
              <RadioGroup aria-label="report" name="reportOptions" value={reason} onChange={handleChange}>
                <StyledReportReasonText
                  value="Suspicious or fake"
                  control={<StyledRadioButton reason={reason} label="Suspicious or fake" />}
                  label={<Typography variant="subtitle2">Suspicious or fake</Typography>}
                />
                <StyledReportReasonText
                  value="Harassment or hateful speech"
                  control={<StyledRadioButton reason={reason} label="Harassment or hateful speech" />}
                  label={<Typography variant="subtitle2">Harassment or hateful speech</Typography>}
                />
                <StyledReportReasonText
                  value="Violence or physical harm"
                  control={<StyledRadioButton reason={reason} label="Violence or physical harm" />}
                  label={<Typography variant="subtitle2">Violence or physical harm</Typography>}
                />
                <StyledReportReasonText
                  value="Adult content"
                  control={<StyledRadioButton reason={reason} label="Adult content" />}
                  label={<Typography variant="subtitle2">Adult content</Typography>}
                />
                <StyledReportReasonText
                  value="Intellectual property infringement or defamation"
                  control={
                    <StyledRadioButton reason={reason} label="Intellectual property infringement or defamation" />
                  }
                  label={<Typography variant="subtitle2" align="left">Intellectual property infringement or defamation</Typography>}
                />
                <StyledReportReasonText
                  value="Offensive or discriminatory"
                  control={<StyledRadioButton reason={reason} label="Offensive or discriminatory" />}
                  label={<Typography variant="subtitle2">Offensive or discriminatory</Typography>}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
      </Box>
    )
}
